module.exports = __webpack_public_path__ + "static/media/seat-selected-symbol.c8b71357.svg";